/**
 * Active-tool store and tool-mode types. The editor host subscribes and
 * forwards changes to the Pixi scene; the scene routes pointer events to
 * the matching tool handler.
 *
 * Phase 2.5 ships three tools:
 *   - 'select' — Phase 2's existing pan / drag-to-move / click-to-select.
 *   - 'road'   — drag-to-paint road tiles (step 10).
 *   - 'store'  — click a placed building to move it to inventory (step 9).
 *
 * Step 6 introduces only the store + dispatch plumbing; the road and store
 * branches are no-ops at this stage. All Phase 2 acceptance criteria stay
 * green because 'select' is the default and nothing flips it.
 */
import { writable, type Writable } from 'svelte/store'

export type ActiveTool = 'select' | 'road' | 'store'

/** Default + safety-net value. Components can subscribe / set freely; the
 *  scene only reacts when the editor host pushes the change in via
 *  scene.setActiveTool(). */
export const activeTool: Writable<ActiveTool> = writable('select')

/** Reset to 'select'. Called by the editor host on mount and on close so a
 *  stale tool from a previous session doesn't leak into a fresh editor. */
export function resetActiveTool(): void {
  activeTool.set('select')
}
